export const TICKABLE_ITEMS = {
  PIPELINE_MOBILE_VIEW: 1,
  INTERCEPT: 2,
  ONBOARDING_SAVE_INFO: 3,
  SETTLEMENT_FINANCIALS: 4,
};
